/**
 * PLP Back-to-top — circular floating button on search/collection PLPs.
 * Appears once the user has scrolled PAST the 20th product card in grid view
 * or the 10th in list view (the card's bottom is above the viewport).
 * Re-evaluates on scroll and on every InstantSearch render (cards re-mount on
 * filter changes and infinite-scroll loads).
 */
(function () {
  'use strict';

  // List rows are taller, so the button earns its place sooner there.
  var THRESHOLD_GRID = 20;
  var THRESHOLD_LIST = 10;
  var btn = null;
  var visible = false;
  var ticking = false;

  function ensureButton() {
    if (btn) return btn;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'plp-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.body.appendChild(btn);
    return btn;
  }

  function evaluate() {
    ticking = false;
    // Exactly one card flavor is rendered at a time (view toggle re-mounts).
    var cards = document.querySelectorAll('.plp-card-list');
    var threshold = THRESHOLD_LIST;
    if (cards.length === 0) {
      cards = document.querySelectorAll('.plp-card-grid');
      threshold = THRESHOLD_GRID;
    }
    var show = false;
    if (cards.length >= threshold) {
      // Past hit N = the Nth card's bottom edge is above the viewport top.
      show = cards[threshold - 1].getBoundingClientRect().bottom < 0;
    }
    if (show !== visible) {
      visible = show;
      ensureButton().classList.toggle('plp-back-to-top--visible', show);
    }
  }

  function requestEvaluate() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(evaluate);
    }
  }

  window.addEventListener('scroll', requestEvaluate, { passive: true });
  window.addEventListener('resize', requestEvaluate, { passive: true });
  document.addEventListener('algolia.instantSearch.onRender', requestEvaluate);
})();
